import { createMiddleware } from "@tanstack/react-start";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";

const BLOCKED = new Set(["suspended", "inactive", "deactivated", "disabled", "banned"]);

/**
 * requireSupabaseAuth + a live account-status check.
 *
 * A JWT stays valid until it expires, so a UI-only deactivation check leaves a
 * deactivated user with working access. This middleware re-reads
 * profiles.status on every server-function call and rejects immediately.
 */
export const requireActiveAuth = createMiddleware({ type: "function" })
  .middleware([requireSupabaseAuth])
  .server(async ({ next, context }) => {
    const { data, error } = await context.supabase
      .from("profiles")
      .select("status")
      .eq("id", context.userId)
      .maybeSingle();

    if (error) throw new Error("Unauthorized: unable to verify account status");
    if (!data) throw new Error("Unauthorized: account not found");

    const status = (data.status ?? "active").toLowerCase();
    if (BLOCKED.has(status)) {
      throw new Error("Account deactivated: contact an administrator.");
    }

    return next({ context: { accountStatus: status } });
  });
